import ReviewExtrasSummary from './ReviewExtrasSummary';

export default ReviewExtrasSummary;
